import React, { Fragment, useEffect, useContext, useState } from "react";
/* mui */
import Typography from "@material-ui/core/Typography";
/* mui */

/* packages */
import { GlobalContext } from "../../lib-atomic-context";
import { FetchContextApiV2 } from "../../lib-atomic-functions";
import { Inputs, Buttons, Invalid } from "../../lib-atomic";
import {
  FormHook,
  LocalStorage,
} from "../../lib-atomic-functions";
import {
  ModuleSubTitle,
  ModuleFormWrapper,
  ModuleFormItemWrapper,
  ModuleFormItemLongWrapper,
  ModulePaperWrapper,
} from "../../lib-atomic-design-section";
/* packages */

import CONFIG from "../config";

/* CONSTANTS */
const PROMOCODEOBJECT = CONFIG.application.config.objects_promocode;
const BUYNOWENDPOINTS = CONFIG.application.config.api.endpoints;
const PROMOCODEOBJECTCONFIG = {
  url: BUYNOWENDPOINTS.promo.url,
  method: BUYNOWENDPOINTS.promo.method,
  headers: BUYNOWENDPOINTS.promo.headers,
  responseType: "json",
};
const PROMOCODEFAILRESPONSE = CONFIG.application.config.responses.promoFail;
const PROMOCODESUCCESSRESPONSE =
  CONFIG.application.config.responses.promoSuccess;
const PROMOMINIMUMRESPONSE =
  "Purchase value should exceed $2,000 (excluding courier).";
/* CONSTANTS */

const index = (props) => {
  const [promoCodePayload, promoCodePayloadSet] = useState("");
  const isPromoLS = LocalStorage.getLS().promocode ? true : false;
  const tokenLS = LocalStorage.getLS().login.token;

  PROMOCODEOBJECTCONFIG.headers.Authorization = tokenLS;

  /* state */
  const [isPromoCode, setIsPromoCode] = useState(false);
  const [isPromoCodeSubmit, setIsPromoCodeSubmit] = useState(false);
  const [loadingPromo, setLoadingPromo] = useState(false);
  const [isBelowMinimum, setIsBelowMinimum] = useState(false);
  /* -------------- */
  /* --- promocode */
  /* -------------- */
  const { promocode, product } = useContext(GlobalContext);
  const [fetchPromoCode] = FetchContextApiV2(PROMOCODEOBJECTCONFIG);
  const execPromoCodeAdd = async ({ headers, query }) => {
    promocode.dispatch({
      type: promocode.actionTypes.ADD_PROMOCODE,
      // promocode: customPromoCode,
      promocode: await fetchPromoCode(
        { newheaders: headers, query },
        promocode
      ),
    });
  };
  const getSubtotalExcludingCourier = () => {
    const productLS = LocalStorage.getLS().products;
    let total = 0;

    productLS &&
      productLS.map((item) => {
        total = total + item.value * item.quantity;
      });

    return total;
  };

  useEffect(() => {
    LocalStorage.addLS("promocode", false);
    setIsPromoCode(false);
    // setIsPromoCodeSubmit(false);
    setIsBelowMinimum(false);
  }, [product]);

  useEffect(() => {
    if (!isPromoCodeSubmit) return;

    const subtotal = getSubtotalExcludingCourier();

    if (!promocode.state || !promocode.state.data) {
      setLoadingPromo(false);
      return;
    }

    const status = promocode.state.data.status;
    if (!status) {
      // console.log("INVALID PROMO");
      setIsPromoCode(false);
      if (subtotal < 2000) {
        setIsBelowMinimum(true);
      } else {
        setIsBelowMinimum(false);
      }
      setLoadingPromo(false);
      LocalStorage.addLS("promocode", false);
      return;
    }

    if (subtotal < 2000) {
      // console.log("BELOW MINIMUM");
      if (promocode.state.data && promocode.state.data.status === true) {
        setIsPromoCode(true);
      } else {
        setIsPromoCode(false);
      }
      setIsBelowMinimum(true);
      setLoadingPromo(false);
      LocalStorage.addLS("promocode", false);
      return;
    }

    // console.log("VALID PROMO OVER 2000");
    setIsPromoCode(true);
    setIsBelowMinimum(false);
    setLoadingPromo(false);

    LocalStorage.addLS("promocode", {
      ...promocode.state.data.data.json.promos[0],
      promoCode: promoCodePayload,
    });
  }, [promocode, promoCodePayload]);

  /* -------------- */
  /* --- promocode */
  /* state */

  const handlePromoCode = async () => {
    setLoadingPromo(true);
    setIsPromoCodeSubmit(true);
    setIsBelowMinimum(false);

    const code = values.promoCode;

    await execPromoCodeAdd({ query: `promoCode=${code}` });

    promoCodePayloadSet(code);
  };

  const { values, onReset, onChange, onSubmit, error } = FormHook.useFormHook(
    handlePromoCode,
    PROMOCODEOBJECT
  );

  const promoCode = {
    ...PROMOCODEOBJECT.promoCode,
    error: error.promoCode,
    value: values.promoCode,
    onChange,
  };
  const submitButton = { size: "large" };
  const failPromo = { error: [PROMOCODEFAILRESPONSE] };
  const successPromo = { error: [PROMOCODESUCCESSRESPONSE] };

  /* data props */
  return (
    <ModuleFormItemLongWrapper>
      <ModulePaperWrapper>
        <ModuleFormWrapper>
          <ModuleFormItemLongWrapper>
            <ModuleSubTitle>
              <b>Promo Code</b>
            </ModuleSubTitle>
            <form onSubmit={onSubmit} noValidate>
              <ModuleFormWrapper>
                {/* line */}
                <ModuleFormItemWrapper>
                  <Inputs.Text {...promoCode} />
                </ModuleFormItemWrapper>
                {/* line */}
                <ModuleFormItemWrapper>
                  {/* INVALID */}
                  {isPromoCodeSubmit && !loadingPromo && !isPromoCode && (
                    <Fragment>
                      <Invalid {...failPromo} />
                      <br />
                    </Fragment>
                  )}

                  {/* BELOW MINIMUM */}
                  {isPromoCodeSubmit && !loadingPromo && isBelowMinimum && isPromoCode && (
                    <Fragment>
                      <Invalid error={[PROMOMINIMUMRESPONSE]} />
                      <br />
                    </Fragment>
                  )}
                </ModuleFormItemWrapper>
                {/* line */}
                <ModuleFormItemWrapper>
                  {/* SUCCESS */}
                  {isPromoCode && isPromoCodeSubmit && !loadingPromo && !isBelowMinimum && (
                    <Fragment>
                      <Typography
                        style={{ color: "#4fd14f" }}
                        variant="caption"
                        display="block"
                        gutterBottom
                      >
                        <b>{successPromo.error}</b>
                      </Typography>
                      <Typography
                        style={{ color: "#4fd14f" }}
                        variant="caption"
                        display="block"
                        gutterBottom
                      >
                        {LocalStorage.getLS().promocode.description}
                      </Typography>
                      <br />
                    </Fragment>
                  )}
                </ModuleFormItemWrapper>
                {/* line */}
              </ModuleFormWrapper>
              <ModuleFormWrapper>
                {/* line */}
                <ModuleFormItemWrapper>
                  <Buttons.Normal {...submitButton}>Apply</Buttons.Normal>
                </ModuleFormItemWrapper>
                {/* line */}
              </ModuleFormWrapper>
            </form>
          </ModuleFormItemLongWrapper>
        </ModuleFormWrapper>
      </ModulePaperWrapper>
    </ModuleFormItemLongWrapper>
  );
};

export default index;
